import { IToggle } from 'unleash-proxy-client';
import { calendlyLinks, calendlyLinkVariantSchema } from './calendlyLinks';
import { FeatureFlagSlug } from './discoveryCallsList';

const delimiter = '__';

export const discoveryCallsPrefix = 'discovery-call';

export const getDiscoveryCallsFlag = (
  allFlags: IToggle[],
  featureFlagSlug: FeatureFlagSlug
) => {
  const flagName = `${discoveryCallsPrefix}-${featureFlagSlug}`;

  const flag = allFlags.find(t => t.name.split(delimiter)[0] === flagName);

  const antiFlag = allFlags.find(
    t => t.name.split(delimiter)[0] === `anti-${flagName}`
  );

  const calendlyLinkKeyParsed = calendlyLinkVariantSchema.safeParse(
    flag?.name.split(delimiter)[1]
  );
  const calendlyLink = calendlyLinkKeyParsed.success
    ? calendlyLinks[calendlyLinkKeyParsed.data]
    : undefined;

  return flag && !antiFlag
    ? { name: flag.name, enabled: true, calendlyLink: calendlyLink ?? null }
    : null;
};
